// v-fit-text="{ max, min, lines }" (sizes in rem): the text wraps between words, on up to `lines` lines,
// and is set smaller until it fits the width of its element, so a long name is never cut or split mid-word
function fit(el, { max = 1.3, min = 0.8, lines = 2 } = {}) {
    let size = max
    el.style.fontSize = `${size}rem`
    const fits = () => {
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || size * 16 * 1.2
        return el.scrollWidth <= el.clientWidth + 1 && el.scrollHeight <= lineHeight * lines + 2
    }
    while (size > min && !fits()) {
        size = Math.max(min, Math.round((size - 0.05) * 100) / 100)
        el.style.fontSize = `${size}rem`
    }
}

export default {
    inserted(el, binding) {
        fit(el, binding.value)
        // the broadcast fonts may still be loading: measure again with them
        if (document.fonts) document.fonts.ready.then(() => fit(el, binding.value))
    },
    componentUpdated(el, binding) {
        fit(el, binding.value)
    }
}
